module.exports = __webpack_public_path__ + "img/6.926fc18a.jpg";